module.exports = __webpack_public_path__ + "images/emoji/crown.2fb0c8e24db16100debc.png";